var map = {
	"./template.bet575": 1103,
	"./template.bet575.tsx": 1103,
	"./template.bet777": 1104,
	"./template.bet777.tsx": 1104,
	"./template.betprofessor": 1105,
	"./template.betprofessor.tsx": 1105,
	"./template.betroyale": 1106,
	"./template.betroyale.tsx": 1106,
	"./template.betstride": 1107,
	"./template.betstride.tsx": 1107,
	"./template.buffalobet": 1108,
	"./template.buffalobet.tsx": 1108,
	"./template.chromabet": 1109,
	"./template.chromabet.tsx": 1109,
	"./template.default": 718,
	"./template.default.tsx": 718,
	"./template.epicodds": 1110,
	"./template.epicodds.tsx": 1110,
	"./template.fiestabet": 2057,
	"./template.fiestabet.tsx": 2057,
	"./template.gigabet": 1118,
	"./template.gigabet.tsx": 1118,
	"./template.goldenbet888": 1119,
	"./template.goldenbet888.tsx": 1119,
	"./template.goldenrush": 1120,
	"./template.goldenrush.tsx": 1120,
	"./template.hyperbet": 1121,
	"./template.hyperbet.tsx": 1121,
	"./template.juicybet": 2058,
	"./template.juicybet.tsx": 2058,
	"./template.junglebet": 2059,
	"./template.junglebet.tsx": 2059,
	"./template.magnumbet": 1122,
	"./template.magnumbet.tsx": 1122,
	"./template.oldgill": 1123,
	"./template.oldgill.tsx": 1123,
	"./template.puntcity": 1124,
	"./template.puntcity.tsx": 1124,
	"./template.puntgenie": 2060,
	"./template.puntgenie.tsx": 2060,
	"./template.pyramidbet": 1125,
	"./template.pyramidbet.tsx": 1125,
	"./template.questbet": 1126,
	"./template.questbet.tsx": 1126,
	"./template.slambet": 1127,
	"./template.slambet.tsx": 1127,
	"./template.sterlingparker": 1128,
	"./template.sterlingparker.tsx": 1128,
	"./template.sugarcastle": 1129,
	"./template.sugarcastle.tsx": 1129,
	"./template.templebet": 1130,
	"./template.templebet.tsx": 1130,
	"./template.titanbet": 1131,
	"./template.titanbet.tsx": 1131,
	"./template.ts": 970,
	"./template.vikingbet": 1132,
	"./template.vikingbet.tsx": 1132,
	"./template.volcanobet": 1133,
	"./template.volcanobet.tsx": 1133,
	"./template.wellbet": 1134,
	"./template.wellbet.tsx": 1134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2426;